import axios from 'axios'
import store from '@state/store'
import router from '@src/router'

import { AppError } from '@/utils/AppError'

export const api = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_PUBLIC_URL_V2,
  timeout: 10000,
})

api.interceptors.request.use((config) => {
  const token = JSON.parse(window.localStorage.getItem('auth.token'))
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => {
    store.commit('ui/STOP_LOADING')
    return response
  },
  (error) => {
    store.commit('ui/STOP_LOADING')

    if (error.response?.status === 401) {
      store.dispatch('auth/logOut')
      router.push({ name: 'login' })
    }

    const err = new AppError(error.response?.data?.message || 'Error inesperado', error.response?.status, error.response?.data)

    return Promise.reject(err)
  },
)
